(function () {
    "use strict";

    angular.module("app").directive("habilMinDateToday", MinDateToday);

    function MinDateToday() {
        return {
            restrict: "A",
            link: SetMin
        };
    }

    function SetMin(_scope, element, _attr) {

        const nativeElement = element[0];
        if (!isDateInput(nativeElement))
            return;

        nativeElement.min = new Date().toISOString().split("T")[0];
        
        function isDateInput(element) {
            if (!(element instanceof HTMLInputElement))
                return false;

            return element.type === 'date';
        }
    }
})();